<section class="tc-requirement-block" aria-labelledby="tc-requirement-block-heading">
  <header class="tc-requirement-block__header">
    <h3 id="tc-requirement-block-heading" class="tc-requirement-block__title">
      {{ 'testCases.form.requirementLink.blockTitle' | translate }}
    </h3>
    @if (requirement()?.key; as key) {
      <code class="tc-requirement-block__ref">{{ key }}</code>
    }
  </header>

  @if (loading()) {
    <div class="tc-requirement-block__loading">
      <mat-spinner diameter="28" />
    </div>
  } @else if (loadError()) {
    <p class="tc-requirement-block__hint tc-requirement-block__hint--error" role="alert">
      {{ 'testCases.form.requirementLink.loadError' | translate }}
    </p>
  } @else if (requirement()) {
    @let req = requirement()!;
    <dl class="tc-requirement-block__fields">
      <dt class="tc-requirement-block__field-label">{{ 'testCases.form.requirementLink.titleField' | translate }}</dt>
      <dd class="tc-requirement-block__value">{{ req.title }}</dd>

      <dt class="tc-requirement-block__field-label">{{ 'testCases.form.requirementLink.description' | translate }}</dt>
      <dd class="tc-requirement-block__value tc-requirement-block__value--multiline">
        {{ req.description || '—' }}
      </dd>
    </dl>
  }
</section>
